import {useCallback, useEffect, useMemo, useRef} from "react";
import MobilePreview from "../../MobilePreview";
import {SURVEY_PREVIEW_MESSAGE, toPreviewMessage} from "../../../libs/surveyQuestions";

/**
 * 설문 미리보기 — **실제 고객 설문 화면**(`/view/survey?temp=true`)을 iframe 으로 띄우고 내용을 postMessage 로 넘긴다. (2026-10-12)
 *
 * 이벤트 화면 미리보기(`EventLoginPreview` 등 `/view/...?temp=true`)와 같은 방식이다. 별도 화면을 그리지 않으므로
 * 고객이 보는 모양(필수 표시·여백·필수 검사 스크롤)과 어긋나지 않는다. 미리보기 화면은 제출하지 않는다(survey.js).
 * 문항이 많아 URL 로는 못 넘기므로, iframe 이 준비 신호(`_READY`)를 보내면 그때와 내용이 바뀔 때 보낸다.
 */
const SurveyPreview = ({title, description, questions}) => {
    const API_HOST = process.env.REACT_APP_API_HOST
    const iframeRef = useRef(null)
    const url = `${API_HOST}/view/survey?temp=true`
    const targetOrigin = useMemo(() => {
        try {
            return new URL(API_HOST).origin
        } catch (e) {
            return "*"
        }
    }, [API_HOST])

    const send = useCallback(() => {
        iframeRef.current?.contentWindow?.postMessage(toPreviewMessage(title, description, questions), targetOrigin)
    }, [title, description, questions, targetOrigin])

    useEffect(() => {
        const onMessage = (e) => {
            if (e.source === iframeRef.current?.contentWindow && e.data?.type === `${SURVEY_PREVIEW_MESSAGE}_READY`) send()
        }
        window.addEventListener("message", onMessage)
        return () => window.removeEventListener("message", onMessage)
    }, [send])

    // 내용이 바뀌면 다시 보낸다(이미 준비된 iframe).
    useEffect(() => { send() }, [send])

    return (
        <div className="flex-col items-center gap-2">
            <MobilePreview>
                <iframe ref={iframeRef} className="relative h-full" src={url} title="OMOPLAY SURVEY PREVIEW" />
            </MobilePreview>
            <p className="text-xs text-gray-500 text-center">
                미리보기에서는 제출되지 않습니다. 편집 중인 내용은 <b>저장해야</b> 고객 화면에 반영됩니다.
            </p>
        </div>
    )
}

export default SurveyPreview
